<template>
    <div
        class="field-text field-wrap"
        v-bind:class="{
            'field-text--has-focus': hasFocus,
            'field-text--has-content': simpleFieldGet.length,
            'field-text--has-textpicker': textpickerNamespace,
            'field-text--has-textpicker-open': textpickerIsOpen
        }"
    >
        <label v-if="label || required" class="field-text__label">
            {{ label }}<span v-if="required" class="field-text__label-required">&nbsp;*</span>
        </label>

        <input
            v-model="simpleFieldModel"
            :type="realType"
            @focus="onFocus"
            @blur="onBlur"
            :disabled="checkDisabled"
            :required="required"
            :pattern="pattern"
            :maxlength="maxlength"
            class="field-text__input"
        />

        <app-textpicker-button
            v-if="textpickerNamespace"
            @click="clickTextpicker"
        ></app-textpicker-button>

        <app-password-reveal-button
            v-if="type == 'password'"
            :passwordIsRevealed="passwordIsRevealed"
            @togglePasswordState="togglePasswordState"
        ></app-password-reveal-button>
    </div>
</template>

<script>
import TextpickerButton from '@/components/assorted/TextpickerButton.vue';
import PasswordRevealButton from '@/components/assorted/PasswordRevealButton.vue';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {
            hasFocus: false,
            textpickerIsOpen: false,
            realType: this.type,
            passwordIsRevealed: false
        };
    },
    components: {
        'app-textpicker-button': TextpickerButton,
        'app-password-reveal-button': PasswordRevealButton
    },
    computed: {
        ...mapGetters(['isTextpickerActive'])
    },
    methods: {
        ...mapActions(['openTextpicker']),
        clickTextpicker() {
            this.openTextpicker({
                namespace: this.textpickerNamespace,
                component: this
            });
        },
        setTextFromTextpicker(value) {
            this.simpleFieldSet(value);
        },
        togglePasswordState() {
            if (this.realType != 'password' && this.realType != 'text') {
                return;
            }
            this.realType = this.realType == 'password' ? 'text' : 'password';
            this.passwordIsRevealed = this.realType == 'text';
        },
        onBlur() {
            this.autoformatValue();
            this.stripHtmlTags();
            this.hasFocus = false;
        },
        onFocus() {
            if (this.isTextpickerActive) {
                this.clickTextpicker();
            }
            this.hasFocus = true;
        }
    },
    mixins: [SimpleFieldMixin],
    props: {
        type: String
    }
};
</script>
